<template>
  <div class="affixStyle">
    <div class="align-right">
      <slot class="close" name="button" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: 0,
    };
  },
};
</script>

<style lang="less" scoped>
.affixStyle{
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  z-index: 1;
}
.align-right {
  text-align: right;
  height: 50px;
  background-color: #ffffff;
  box-shadow: 0px -5px 5px -5px rgba(0, 0, 0, 0.2);
  padding-top: 10px;
  padding-bottom: 10px;
  box-sizing: border-box;
  padding-right: 30px;
  box-sizing: border-box;
  .close{
    margin-right: 30px;
  }
}
</style>
